"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Tip;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const merge_1 = require("merge");
const TipBox_1 = require("./TipBox");
const types_1 = require("./types");
const Chip_1 = require("../Chip");
const TipBoxFooter_1 = require("./TipBoxFooter");
const StackElements_1 = require("../StackElements");
const DisplayModes_1 = require("./DisplayModes");
const index_style_1 = require("./index.style");
function Tip({ option, tipSelectHandler, tipMode, tip, amount, convertAmount, blackThemeStyle, mostCommon, cancelIcon, calculatedAmount, sx, id, tipLabelType, index, isTipLabelType, descriptions, currencyFormat, isIncludeZero, shouldStretchBoxes, }) {
    const selected = tip === option;
    const isTipLabelIconType = tipLabelType === 'stars' || tipLabelType === 'ticks';
    const { mostCommonStyle, tipBoxContainer, container, stack } = (0, index_style_1.default)({
        isTipLabelIconType,
        shouldStretchBoxes,
        blackThemeStyle,
        selected,
    });
    const tipContent = () => {
        switch (tipMode) {
            case types_1.TipModeEnum.Percentage:
            case types_1.TipModeEnum.PercentWithRoundUp:
            case types_1.TipModeEnum.Fixed:
                return ((0, jsx_runtime_1.jsx)(DisplayModes_1.PercentageTipAndFixedTip, { currencyFormat: currencyFormat, option: option, tipMode: tipMode, value: convertAmount(option), isTipLabelType: isTipLabelType }));
            case types_1.TipModeEnum.PercentageWithHint:
            case types_1.TipModeEnum.PercentWithHintAndRoundUp:
                return ((0, jsx_runtime_1.jsx)(DisplayModes_1.PercentageWithHintTip, { option: option, calculatedAmount: calculatedAmount, currencyFormat: currencyFormat }));
            case types_1.TipModeEnum.FixedWithHint:
                return ((0, jsx_runtime_1.jsx)(DisplayModes_1.FixedWithHintTip, { value: convertAmount(option), option: option, amount: amount, currencyFormat: currencyFormat }));
            default:
                return null;
        }
    };
    return ((0, jsx_runtime_1.jsxs)(StackElements_1.StackElements, { direction: "column", alignItems: "center", justifyContent: "center", style: stack, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: (0, merge_1.merge)(true, container, sx), children: (0, jsx_runtime_1.jsxs)(StackElements_1.StackElements, { direction: "column", alignItems: "center", justifyContent: "center", children: [(0, jsx_runtime_1.jsx)(TipBox_1.default, { insideTipV2: true, sx: (0, merge_1.merge)(true, tipBoxContainer, sx), blackThemeStyle: blackThemeStyle, selected: selected, onClick: tipSelectHandler(option), closeIcon: cancelIcon, id: id, shouldStretchBoxes: shouldStretchBoxes, children: !!tipContent && tipContent() }), isTipLabelType && ((0, jsx_runtime_1.jsx)(TipBoxFooter_1.default, { tipLabelType: tipLabelType, indexNo: index, selected: selected, descriptions: descriptions, option: option, blackThemeStyle: blackThemeStyle, isIncludeZero: isIncludeZero, onClick: tipSelectHandler(option) }))] }) }), mostCommon && (0, jsx_runtime_1.jsx)(Chip_1.default, { sx: mostCommonStyle, label: "Most Common" })] }));
}
